import { render, staticRenderFns } from "./bomcost.vue?vue&type=template&id=7015859a&scoped=true&"
import script from "./bomcost.vue?vue&type=script&lang=js&"
export * from "./bomcost.vue?vue&type=script&lang=js&"
import style0 from "./bomcost.vue?vue&type=style&index=0&id=7015859a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015859a",
  null
  
)

export default component.exports